module.exports = __webpack_public_path__ + "static/media/Paris Thorsten technoman.8823ba58.jpg";